import { Link, usePathname } from "@shared/client/navigation";
import { cn } from "@shared/lib/utils";

/**
 * Onglets de la prospection : des lieux, pas des actions. L'onglet actif se
 * lit au trait et au gris foncé ; un compteur signale ce qui attend quelqu'un.
 */

const TABS = [
  { href: "/admin/prospection", label: "Prospects", key: "prospects" },
  { href: "/admin/prospection/envois", label: "Envois", key: "outbox" },
  { href: "/admin/prospection/reponses", label: "Réponses", key: "replies" },
  { href: "/admin/prospection/boites", label: "Boîtes d’envoi", key: "mailboxes" },
  { href: "/admin/prospection/reglages", label: "Réglages", key: "settings" },
] as const;

export function ProspectionTabs({ counts }: { counts: Partial<Record<(typeof TABS)[number]["key"], number>> }) {
  const pathname = usePathname();
  const active =
    TABS.slice(1).find((tab) => pathname === tab.href || pathname.startsWith(`${tab.href}/`))?.key ?? "prospects";

  return (
    <nav aria-label="Prospection" className="mb-5 flex flex-wrap gap-x-5 gap-y-1 border-b max-sm:-mx-4 max-sm:flex-nowrap max-sm:overflow-x-auto max-sm:px-4 max-sm:[scrollbar-width:none]">
      {TABS.map((tab) => {
        const count = counts[tab.key];
        return (
          <Link
            aria-current={active === tab.key ? "page" : undefined}
            className={cn(
              "-mb-px inline-flex shrink-0 items-center gap-1.5 border-b-2 border-transparent py-2.5 text-[13px] whitespace-nowrap font-medium text-muted-foreground transition-colors hover:text-foreground",
              active === tab.key && "border-foreground text-foreground",
            )}
            href={tab.href}
            key={tab.key}
          >
            {tab.label}
            {count ? <span className="text-[12px] text-subtle-foreground tabular-nums">{count}</span> : null}
          </Link>
        );
      })}
    </nav>
  );
}
